import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

export enum VerificationType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
}

interface Body {
  employeeId: string;
  value: string;
  type: VerificationType;
  isLink?: boolean;
}

const useSendVerificationQuery = () => {
  const { mutateAsync, isLoading, isError } = useMutation((body: Body) =>
    api.post(API_URL.CODES_VERIFICATIONS, {
      employee_id: body.employeeId,
      value: body.value,
      type: body.type,
      is_link: body.isLink,
    })
  );

  return {
    sendVerification: mutateAsync,
    isLoading,
    isError,
  };
};

export default useSendVerificationQuery;
